







import Quill from 'quill'

export default { 
  props: 
    id: null
    value: 
      ops: []
    author: {}
    formats: 
        type: Array
        default: () ->
            []
    keyBindings:
        type: Array
        default: () ->
            []
    output:
        default : 'delta'
    keyup:
        default : null

  data: () ->
    editor: {},

  mounted: () ->
    that = this
    @editor = new Quill @$refs.editor, 
      theme: 'snow'
      modules:
        toolbar: true

    @formats.map (format) ->
      @editor.addFormat format.name, format.options 

    if @output != 'delta'
      @editor.setHTML @value
    else
      @editor.setContents @value

    @editor.on 'text-change', (delta, old, source) ->
      value = if that.output != 'delta' then that.editor.getHTML() else that.editor.getContents()
      that.value.ops = value.ops

    # @editor.on 'selection-change', (range) ->
      # @$emit('selection-change', @editor, range)

    if typeof @author != 'undefined'
      @editor.addModule 'authorship', 
          authorId: @author

    if @keyBindings.length
      keyboard = @editor.getModule 'keyboard'

      @keyBindings.map (binding) ->
        keyboard.addHotkey({ key: binding.key, metaKey: true }, binding.method.bind(this))

  events:
    'set-content' : (content) ->
      @editor.setContents content

    'set-html' : (html) ->
      @editor.setHTML html

    'focus-editor' : () ->
      @focusEditor()

  methods:
    sync: () ->
      @$nextTick () ->
        @editor.setContents @value.ops

    focusEditor: (e) ->
      if e && e.srcElement 
        classList = e.srcElement.classList
        isSegment = false

        for className in classList
          if className == 'segment'
            isSegment = true
            return

        if !isSegment then return

      @editor.focus()

      @editor.setSelection(@editor.getLength()-1, @editor.getLength())

}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/form/Editor.vue